import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { map, Observable, race, retry, switchMap, timer } from 'rxjs';
import { randomString } from './helpers/random-string';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private platformId = inject(PLATFORM_ID);
  public networkStatus: boolean;
  private http = inject(HttpClient);
  public online$ = race([
    new Observable(observer => {
      const onlineHandler = () => {
        observer.next(true);
        observer.complete();
      };
      if (isPlatformServer(this.platformId)) {
        return onlineHandler();
      }
      if (window.navigator.onLine) return onlineHandler();
      window.addEventListener('online', onlineHandler, { passive: true });
      return () => window.removeEventListener('online', onlineHandler);
    }),
    timer(10_000).pipe(switchMap(() => this.http.head(`/resources/network-test.json?cachebust=${randomString(12)}`))),
  ]).pipe(
    retry(),
    map(() => true)
  );
}
